import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-secondary text-foreground shadow hover:bg-secondary",
        secondary:
          "border-transparent bg-muted text-foreground hover:bg-secondary",
        destructive:
          "border-transparent bg-red-900/50 text-red-400 shadow hover:bg-red-900/70",
        success:
          "border-transparent bg-green-900/50 text-green-400 shadow hover:bg-green-900/70",
        warning:
          "border-transparent bg-yellow-900/50 text-yellow-400 shadow hover:bg-yellow-900/70",
        outline: "border-border text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
